import { render } from "./SpinnerCountries.vue?vue&type=template&id=70d5db3e"
import script from "./SpinnerCountries.vue?vue&type=script&lang=js"
export * from "./SpinnerCountries.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__